import React, { useState } from 'react';
import { Button, Modal, Card, Typography, Row, Col } from 'antd';
import { FileOutlined, PictureOutlined } from '@ant-design/icons';
import DocumentUpload from './DocumentUpload';
import TechnicalDrawing from './TechnicalDrawing';
import './style.css';

const { Text, Title } = Typography;

const AllAssets = () => {
  const [currentView, setCurrentView] = useState('selection'); // 'selection', 'technical-drawing', 'files'
  const [isModalVisible, setIsModalVisible] = useState(false);

  const handleInsertSuccess = () => {
    setIsModalVisible(true);
  };

  const handleModalOk = () => {
    setIsModalVisible(false);
    setCurrentView('selection');
  };

  const renderSelectionView = () => (
    <div style={{ textAlign: 'center', padding: '60px 20px' }}>
      <Title level={2}>Selecione uma opção para continuar</Title>
      <Text type="secondary" style={{ fontSize: '16px', marginBottom: '40px', display: 'block' }}>
        Escolha como você deseja adicionar ativos ao sistema
      </Text>
      
      <Row gutter={[24, 24]} justify="center">
        <Col xs={24} sm={12} md={8}>
          <Card 
            hoverable
            style={{ height: '200px', display: 'flex', flexDirection: 'column', justifyContent: 'center' }}
            onClick={() => setCurrentView('files')}
          >
            <div style={{ textAlign: 'center' }}>
              <FileOutlined style={{ fontSize: '48px', color: '#1890ff', marginBottom: '16px' }} />
              <Title level={4} style={{ margin: '0 0 8px 0' }}>Upload de Arquivos</Title>
              <Text type="secondary">
                Faça upload de arquivos para processamento e inserção de ativos
              </Text>
            </div>
          </Card>
        </Col>
        
        <Col xs={24} sm={12} md={8}>
          <Card 
            hoverable
            style={{ height: '200px', display: 'flex', flexDirection: 'column', justifyContent: 'center' }}
            onClick={() => setCurrentView('technical-drawing')}
          >
            <div style={{ textAlign: 'center' }}>
              <PictureOutlined style={{ fontSize: '48px', color: '#52c41a', marginBottom: '16px' }} />
              <Title level={4} style={{ margin: '0 0 8px 0' }}>Desenho Técnico</Title>
              <Text type="secondary">
                Upload de imagens de desenhos técnicos para análise
              </Text>
            </div>
          </Card>
        </Col>
      </Row>
    </div>
  );

  return (
    <div className='instrumentsContent'>
      {currentView === 'selection' && renderSelectionView()}
      {currentView === 'technical-drawing' && (
        <TechnicalDrawing 
          onBack={() => setCurrentView('selection')}
          onInsertSuccess={handleInsertSuccess}
        />
      )}
      {currentView === 'files' && (
        <DocumentUpload 
          onBack={() => setCurrentView('selection')}
          onInsertSuccess={handleInsertSuccess}
        />
      )}

      <Modal
        title="Sucesso"
        open={isModalVisible}
        onOk={handleModalOk}
        onCancel={handleModalOk}
        cancelButtonProps={{ style: { display: 'none' } }}
      >
        <p>Os ativos foram inseridos com sucesso!</p>
      </Modal>
    </div>
  );
};

export default AllAssets;
